import {
  SIGN_IN,
  SIGN_OUT,
  UPDATE_OFFSET,
  SET_CURRENT_PAGINATION_CONFIG,
  SET_SCREEN_SCROLL_OFFSET,
  SET_CATEGORIES_SORTING_MODE,
  SET_BANNER_IS_OPEN,
} from './constants'

export const signIn = (user) => ({
  type: SIGN_IN,
  payload: user,
})

export const signOut = () => ({
  type: SIGN_OUT,
})

export const updateOffset = (offset) => ({
  type: UPDATE_OFFSET,
  payload: offset,
})

export const setCurrentPaginationConfig = ({
  screen,
  page,
  per,
}) => ({
  type: SET_CURRENT_PAGINATION_CONFIG,
  payload: {
    screen,
    page,
    per,
  },
})

export const setScreenScrollOffset = ({ screen, offset }) => ({
  type: SET_SCREEN_SCROLL_OFFSET,
  payload: {
    screen,
    offset,
  },
})

export const setCategoriesSortingMode = (payload) => ({
  type: SET_CATEGORIES_SORTING_MODE,
  payload,
})

export const setBannerIsOpen = (value, route) => ({
  type: SET_BANNER_IS_OPEN,
  payload: { value, route },
})
